<button
  id="close-footbar"
  type="button"
  class="close"
  aria-label="Close"
  [mat-dialog-close]="false">
  <span aria-hidden="true">×</span>
</button>
<h2 mat-dialog-title>{{ 'k002578' | translate }} </h2>
<mat-dialog-content class="content">
  <div>{{ 'k002579' | translate }}</div>
  <div class="panelpartial">
    <mat-expansion-panel  id="expansionnone" class="bg-light-grey" (opened)="isOpen = true" (closed)="isOpen=false">
      <mat-expansion-panel-header>
        <mat-panel-title  class="c11 pointer w-100 d-block">
          {{ 'k003000' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngIf="isOpen">
      <div class="divvarios">
        <span>{{ 'k002580' | translate }}</span>
      </div>
      <div class="tech-popup-btns" mat-dialog-actions>
      <button  class="buttonPortal cancel my-4" [mat-dialog-close]="true">
        {{ 'k002581' | translate }}<!--k002311 buttonPortal mg cancel my-4-->
      </button>
      <button class="btnNuevo" mat-flat-button #buttonS color="primary" (click)="deletepartialW()" >
        {{ 'k002582' | translate }}<!--k000018-->
      </button>
      </div>
    </ng-container>
    </mat-expansion-panel>
  </div>
</mat-dialog-content>
